import React from 'react';
import '../../assets/sass/_globals.scss';
import './layouts.scss';

const FullWidthLayout = ({ children }) => (
  <main className={'container__full'}>{children}</main>
);

export default FullWidthLayout;
